import { Card } from 'antd'
import './SelectPage.css'
import React from 'react'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useNavigate } from 'react-router-dom';

const SelectPage = () => {

    const navigate = useNavigate();

    return (
        <div className='emailConfigMainClass'>
            <h2>Select type</h2>
            <div className='selectCardDiv'>
                <Card hoverable onClick={() => navigate('/emailconfigurations/courses')}>
                    <h2>Courses</h2>
                    <ArrowRightAltIcon />
                </Card>
                <Card hoverable onClick={() => navigate('/emailconfigurations/trainings')}>
                    <h2>Trainings</h2>
                    <ArrowRightAltIcon />
                </Card>
            </div>
        </div>
    )
}

export default SelectPage